/* DESKIZO Facebook-style reviews: block selecting, copying, cutting, dragging and the
   right-click menu inside the section (the theme editor stays fully usable). */
(() => {
  if (window.Shopify && window.Shopify.designMode) return;
  const blocked = ['contextmenu', 'copy', 'cut', 'dragstart', 'selectstart'];
  document.querySelectorAll('[data-dz-protect]').forEach((el) => {
    blocked.forEach((type) => el.addEventListener(type, (e) => e.preventDefault()));
  });
})();
